(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gyp-community"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gyp-early-offer')){
 class GypEarlyOffer extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.querySelector('[data-early-cta]')?.addEventListener('click',()=>{
    const planner=document.querySelector('gyp-quote-site');
    if(!planner?.panel)return;
    const input=planner.panel.querySelector('input[value="christmas"]');
    if(input)input.checked=true;
    planner.earlyOffer=this.dataset.offer;
    planner.showStep(0,false);
   });
  }
 }
 customElements.define('gyp-early-offer',GypEarlyOffer);
}
if(!customElements.get('gyp-gift-drive')){
 class GypGiftDrive extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.text=JSON.parse(this.querySelector('[data-gift-text]').textContent);
   this.amount='';
   this.addEventListener('click',async event=>{
    const option=event.target.closest('[data-gift-amount]');
    if(option){
     this.amount=option.dataset.giftAmount;
     this.querySelectorAll('[data-gift-amount]').forEach(b=>b.setAttribute('aria-pressed',String(b===option)));
     this.querySelector('[data-gift-status]').textContent=this.text.selected.replace('__AMOUNT__',this.amount);
     this.querySelector('[data-gift-prepared]').hidden=true;
    }
    if(event.target.closest('[data-gift-copy]')){
     const status=this.querySelector('[data-gift-status]');
     if(!this.amount){status.textContent=this.text.required;return;}
     const plan=this.text.plan.replace('__AMOUNT__',this.amount);
     const output=this.querySelector('[data-gift-prepared]');output.textContent=plan;output.hidden=false;
     try{if(!navigator.clipboard?.writeText)throw new Error('Clipboard unavailable');await navigator.clipboard.writeText(plan);status.textContent=this.text.copied;}catch{status.textContent=this.text.fallback;}
    }
   });
  }
 }
 customElements.define('gyp-gift-drive',GypGiftDrive);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gyp-early"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gyp-early-offer')){
 class GypEarlyOffer extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.querySelector('[data-early-cta]')?.addEventListener('click',()=>{
    const planner=document.querySelector('gyp-quote-site');
    if(!planner?.panel)return;
    const input=planner.panel.querySelector('input[value="christmas"]');
    if(input)input.checked=true;
    planner.earlyOffer=this.dataset.offer;
    planner.showStep(0,false);
   });
  }
 }
 customElements.define('gyp-early-offer',GypEarlyOffer);
}
if(!customElements.get('gyp-gift-drive')){
 class GypGiftDrive extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.text=JSON.parse(this.querySelector('[data-gift-text]').textContent);
   this.amount='';
   this.addEventListener('click',async event=>{
    const option=event.target.closest('[data-gift-amount]');
    if(option){
     this.amount=option.dataset.giftAmount;
     this.querySelectorAll('[data-gift-amount]').forEach(b=>b.setAttribute('aria-pressed',String(b===option)));
     this.querySelector('[data-gift-status]').textContent=this.text.selected.replace('__AMOUNT__',this.amount);
     this.querySelector('[data-gift-prepared]').hidden=true;
    }
    if(event.target.closest('[data-gift-copy]')){
     const status=this.querySelector('[data-gift-status]');
     if(!this.amount){status.textContent=this.text.required;return;}
     const plan=this.text.plan.replace('__AMOUNT__',this.amount);
     const output=this.querySelector('[data-gift-prepared]');output.textContent=plan;output.hidden=false;
     try{if(!navigator.clipboard?.writeText)throw new Error('Clipboard unavailable');await navigator.clipboard.writeText(plan);status.textContent=this.text.copied;}catch{status.textContent=this.text.fallback;}
    }
   });
  }
 }
 customElements.define('gyp-gift-drive',GypGiftDrive);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gyp-services"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gyp-quote-site')) {
  class GypQuoteSite extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.panel = this.querySelector('[data-gyp-form]');
      if (!this.panel) return;
      this.initialized = true;
      this.text = JSON.parse(this.querySelector('[data-gyp-text]').textContent);
      this.step = 0;
      this.sending = this.dataset.sending === 'true';
      this.panel.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]')) this.advance();
        if (event.target.closest('[data-back]')) this.showStep(Math.max(0, this.step - 1));
        if (event.target.closest('[data-copy]')) this.copyRequest();
        if (event.target.closest('[data-reset]')) this.resetPlan();
      });
      this.panel.addEventListener('input', (event) => {
        if (event.target.matches('[data-key]')) {
          event.target.setCustomValidity('');
          event.target.removeAttribute('aria-invalid');
        }
      });
      this.panel.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.tagName === 'INPUT' && event.target.type !== 'checkbox') {
          event.preventDefault();
          if (this.step < 2) this.advance();
        }
      });
      this.querySelectorAll('[data-select-service]').forEach((link) => {
        link.addEventListener('click', () => {
          const input = this.panel.querySelector(`input[value="${link.dataset.selectService}"]`);
          if (input) input.checked = true;
          this.showStep(0, false);
        });
      });
      const nativeForm = this.panel.closest('form');
      if (nativeForm) nativeForm.addEventListener('submit', (event) => {
        if (!this.sending || this.step !== 2 || !this.validateServices() || !this.validateDetails()) {
          event.preventDefault();
          return;
        }
        this.renderReview();
      });
      this.showStep(0, false);
    }
    field(key) { return this.panel.querySelector(`[data-key="${key}"]`); }
    value(key) { return this.field(key).value.trim(); }
    selected() { return [...this.panel.querySelectorAll('input[name="gyp_services"]:checked')]; }
    error(message) {
      const output = this.panel.querySelector('[data-error]');
      output.textContent = message || '';
      output.hidden = !message;
    }
    showStep(step, focus = true) {
      this.step = step;
      this.error('');
      this.panel.querySelectorAll('[data-step]').forEach((panel) => { panel.hidden = Number(panel.dataset.step) !== step; });
      this.querySelectorAll('[data-progress]').forEach((item) => {
        if (Number(item.dataset.progress) === step) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      if (focus) this.panel.querySelector(`[data-step="${step}"] [data-step-heading]`).focus({preventScroll: true});
      if (focus) this.querySelector('.gyp-planner').scrollIntoView({behavior:'auto', block:'start'});
    }
    validateServices() {
      if (this.selected().length) return true;
      this.showStep(0);
      this.error(this.text.missing);
      this.panel.querySelector('input[name="gyp_services"]').focus({preventScroll: true});
      return false;
    }
    validateDetails() {
      this.field('state').value = this.value('state').toUpperCase();
      const fields = [...this.panel.querySelectorAll('[data-step="1"] [data-key]')];
      fields.forEach((field) => {
        field.setCustomValidity('');
        field.removeAttribute('aria-invalid');
        if (field.required && !field.value.trim()) field.setCustomValidity(this.text.invalid);
      });
      const phone = this.field('phone');
      const digits = phone.value.replace(/\D/g, '');
      const requiresPhone = this.value('preferred') !== 'email';
      if ((requiresPhone || phone.value.trim()) && (digits.length < 7 || digits.length > 15 || /[A-Za-z]/.test(phone.value))) phone.setCustomValidity(this.text.phoneNeeded);
      const invalid = fields.filter((field) => !field.checkValidity());
      if (invalid.length) {
        this.showStep(1);
        invalid.forEach((field) => field.setAttribute('aria-invalid', 'true'));
        this.error(invalid[0] === phone ? this.text.phoneNeeded : this.text.invalid);
        invalid[0].focus({preventScroll:true});
        invalid[0].reportValidity();
        return false;
      }
      return true;
    }
    advance() {
      if (this.step === 0 && this.validateServices()) this.showStep(1);
      else if (this.step === 1 && this.validateServices() && this.validateDetails()) {
        this.renderReview();
        this.showStep(2);
        this.panel.querySelector('[data-status]').textContent = this.sending ? '' : this.text.ready;
      }
    }
    reviewItems() {
      const property = this.field('property');
      const preferred = this.field('preferred');
      const address = [this.value('street'), this.value('unit'), `${this.value('city')}, ${this.value('state')} ${this.value('zip')}`].filter(Boolean).join('\n');
      const contact = [this.value('name'), this.value('email'), this.value('phone'), `${this.text.preferredLabel}: ${preferred.selectedOptions[0].textContent}`].filter(Boolean).join('\n');
      const job = [`${this.text.propertyLabel}: ${property.value ? property.selectedOptions[0].textContent : this.text.unspecified}`, `${this.text.timingLabel}: ${this.value('timing') || this.text.unspecified}`, this.value('notes') || this.text.noNotes].join('\n');
      const items = [
        [this.text.services, this.selected().map((input) => input.dataset.serviceLabel).join('\n')],
        [this.text.address, address], [this.text.contact, contact], [this.text.job, job],
        [this.text.marketing, this.field('marketing').checked ? this.text.marketingYes : this.text.marketingNo]
      ];
      if (this.earlyOffer && this.selected().some(input => input.value === 'christmas')) items.splice(1, 0, [this.text.offer, this.earlyOffer]);
      return items;
    }
    renderReview() {
      const items = this.reviewItems();
      const list = document.createElement('dl');
      items.forEach(([heading, content]) => {
        const wrapper = document.createElement('div');
        const term = document.createElement('dt');
        const detail = document.createElement('dd');
        term.textContent = heading;
        detail.textContent = content;
        wrapper.append(term, detail);
        list.append(wrapper);
      });
      this.panel.querySelector('[data-review]').replaceChildren(list);
      this.summary = `${this.text.title}\n\n${items.map(([heading, content]) => `${heading}\n${content}`).join('\n\n')}\n\n${this.text.estimateTitle}\n${this.text.estimatePending}\n${this.text.finalNotice}`;
      this.panel.querySelector('[data-body]').value = this.summary;
      this.panel.querySelector('[data-copy-text]').value = this.summary;
    }
    async copyRequest() {
      if (!this.validateServices() || !this.validateDetails()) return;
      this.renderReview();
      const status = this.panel.querySelector('[data-status]');
      this.panel.querySelector('[data-copy-box]').hidden = false;
      try {
        if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(this.summary);
        status.textContent = this.text.copied;
      } catch {
        status.textContent = this.text.copyFailed;
        const text = this.panel.querySelector('[data-copy-text]');
        text.focus({preventScroll:true});
        text.select();
      }
    }
    resetPlan() {
      this.earlyOffer = '';
      this.panel.querySelectorAll('[data-key],input[name="gyp_services"]').forEach((field) => {
        if (field.type === 'checkbox') field.checked = false;
        else if (field.tagName === 'SELECT') field.selectedIndex = 0;
        else field.value = field.dataset.key === 'state' ? 'CA' : '';
        field.setCustomValidity('');
        field.removeAttribute('aria-invalid');
      });
      this.summary = '';
      this.panel.querySelector('[data-body]').value = '';
      this.panel.querySelector('[data-copy-text]').value = '';
      this.panel.querySelector('[data-copy-box]').hidden = true;
      this.panel.querySelector('[data-status]').textContent = '';
      this.panel.querySelector('[data-review]').replaceChildren();
      this.showStep(0);
    }
  }
  customElements.define('gyp-quote-site', GypQuoteSite);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gyp-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gyp-shop-catalog')) {
  class GypShopCatalog extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.text = JSON.parse(this.querySelector('[data-shop-text]').textContent);
      this.grid = this.querySelector('[data-shop-grid]');
      this.cards = [...this.querySelectorAll('[data-shop-card]')];
      this.category = 'all';
      this.querySelector('[data-shop-search]').addEventListener('input',()=>this.filter());
      this.querySelector('[data-shop-sort]').addEventListener('change',()=>this.filter());
      this.addEventListener('click',(event)=>{
        const filter = event.target.closest('[data-shop-category]');
        if (filter) {
          this.category = filter.dataset.shopCategory;
          this.filter();
          if (filter.classList.contains('gyp-shop-category')) this.querySelector('[data-shop-search]').focus({preventScroll:true});
        }
        const button = event.target.closest('[data-shop-detail]');
        if (button) this.openDetail(button.closest('[data-shop-card]'),button);
        const close = event.target.closest('[data-shop-close]');
        if (close) close.closest('dialog').close();
        const copy = event.target.closest('[data-shop-copy]');
        if (copy) this.copyPlan(copy.closest('.gyp-shop-dialog'));
      });
      this.querySelectorAll('dialog').forEach(dialog=>{
        dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
        dialog.addEventListener('close',()=>this.lastButton?.focus({preventScroll:true}));
      });
      this.filter();
    }
    filter() {
      const query=this.querySelector('[data-shop-search]').value.trim().toLowerCase();
      const sort=this.querySelector('[data-shop-sort]').value;
      const ordered=[...this.cards];
      if(sort==='price_low')ordered.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
      else if(sort==='price_high')ordered.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
      else if(sort==='name')ordered.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));
      else ordered.sort((a,b)=>Number(a.dataset.order)-Number(b.dataset.order));
      let count=0;
      ordered.forEach(card=>{
        card.hidden=!((this.category==='all'||card.dataset.category===this.category)&&card.dataset.search.includes(query));
        if(!card.hidden)count++;
        this.grid.append(card);
      });
      this.querySelectorAll('.gyp-shop-tabs [data-shop-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.shopCategory===this.category)));
      this.querySelector('[data-shop-count]').textContent=this.text.results.replace('__COUNT__',String(count));
      this.querySelector('[data-shop-empty]').hidden=count!==0;
    }
    openDetail(card,button) {
      this.lastButton=button;
      const dialog=card.querySelector('dialog');
      if(typeof dialog.showModal==='function')dialog.showModal();
      else dialog.setAttribute('open','');
    }
    async copyPlan(dialog) {
      const input=dialog.querySelector('[data-shop-name]');
      const status=dialog.querySelector('[data-shop-copy-status]');
      status.classList.remove('gyp-shop-error');
      if(input && !input.value.trim()) {
        status.textContent=this.text.required;
        status.classList.add('gyp-shop-error');
        input.focus();
        return;
      }
      const name=input?.value.trim()||'';
      if(name.length>20){status.textContent=this.text.tooLong;input.focus();return;}
      const title=dialog.querySelector('h3').textContent.trim();
      const request=title+(name?'\n'+this.text.personalization+': '+name:'')+'\n'+this.text.previewOnly;
      const output=dialog.querySelector('[data-shop-prepared]');
      output.textContent=request;
      output.hidden=false;
      try {
        if(!navigator.clipboard?.writeText)throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(request);
        status.textContent=this.text.copied;
      }catch{status.textContent=this.text.copyFallback;}
    }
  }
  customElements.define('gyp-shop-catalog',GypShopCatalog);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
